import { configuration } from './environment';

/**
 * Returns the ERP base URL.
 * On the client (browser), we use the local proxy path to avoid CORS issues.
 * On the server, we use the absolute URL for direct communication.
 */
export function getErpBaseUrl(): string {
  if (typeof window !== 'undefined') {
    return '/erp-proxy';
  }
  return configuration.imtErpUrl;
}
